export const customURLSearchParams = () => {  
  const params = new URLSearchParams(window.location.search);

  return {
    append: (name, value) => params.append(name, value),

    delete: (name, value) => 
    {
        params.forEach((itemValue, itemKey) => 
        {
            if(name) {
                if(value) {
                    if(name.toLowerCase() === itemKey.toLowerCase() && value.toLowerCase() === itemValue.toLowerCase()) params.delete(itemKey, itemValue);
                } else {
                    if(name.toLowerCase() === itemKey.toLowerCase()) params.delete(itemKey, itemValue);
                }
            }
        });
    },

    entries: () => params.entries(),

    forEach: (callback, thisArg) => params.forEach(callback, thisArg),

    get: (name) => {
        var result = null;
        for (const key of params.keys()) {
            if(name.toLowerCase() === key.toLowerCase()) result = params.get(key);
        };
        return result;
    },

    getAll: (name) => params.getAll(name),

    has: (name, value) => {
        var found = false;
        params.forEach((itemValue, itemKey) => 
        {
            if(name) {
                if(value) {
                    if(name.toLowerCase() === itemKey.toLowerCase() && value.toLowerCase() === itemValue.toLowerCase()) found = true;
                } else {
                    if(name.toLowerCase() === itemKey.toLowerCase()) found = true;
                }
            }
        });
        return found;
    },

    keys: () => params.keys(),

    set: (name, value) => params.set(name, value),

    sort: () => params.sort(),

    toString: () => params.toString(),

    values: () => params.values()
  }
}

export default customURLSearchParams;